export default __webpack_public_path__ + "static/github-live-typing-00ca326c5a4d75097645288ead0e7ca9.png";